/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext, ThemeService } from '@gh/builder-shared';
import { TranslationService } from '@gh/core-mls';
import { NotificationService, WaitingService } from '@gh/core-ui';
import { from$ } from '@gh/rx';
import { switchMap$ } from '@gh/rx/operators';
import { ColorSchemePickerBusinessService } from '../../resources/color-scheme-picker-business.service';

@Component({
  standalone: false,
  selector: 'gh-color-scheme-picker',
  templateUrl: 'color-scheme-picker.component.html',
  styleUrls: ['color-scheme-picker.component.scss'],
})
export class ColorSchemePickerComponent {
  schemes = [{
    name: 'blue',
    primaryId: 'blue',
    primary: '#03a9f4',
    primaryName: this.translations.get('lbl_blue'),
    accentId: 'magenta',
    accent: '#e91e63',
    accentName: this.translations.get('lbl_magenta'),
  }, {
    name: 'red',
    primaryId: 'red',
    primary: '#ef5350',
    primaryName: this.translations.get('lbl_red'),
    accentId: 'white',
    accent: 'white',
    accentName: this.translations.get('lbl_white'),
  }, {
    name: 'purple',
    primaryId: 'purple',
    primary: '#5D3891',
    primaryName: this.translations.get('lbl_purple'),
    accentId: 'orange',
    accent: '#F99417',
    accentName: this.translations.get('lbl_orange'),
  }, {
    name: 'green',
    primaryId: 'green',
    primary: '#43a047',
    primaryName: this.translations.get('lbl_green'),
    accentId: 'orange',
    accent: '#ff5722',
    accentName: this.translations.get('lbl_orange'),
  }];

  get scheme(): string {
    return this.userContext.colorScheme;
  }

  constructor(private translations: TranslationService,
              private waitings: WaitingService,
              private notifications: NotificationService,
              private userContext: BuilderUserContext,
              private business: ColorSchemePickerBusinessService,
              private themes: ThemeService) {
  }

  onChange(scheme: string): void {
    from$(this.themes.load(scheme)).pipe(
      switchMap$(() => this.business.update(scheme)),
      this.waitings.operator())
      .subscribe(
        () => {
          this.themes.use(scheme);
          this.userContext.changeColorScheme(scheme);
        },
        this.notifications.processAll);
  }
}
